import {
  GET_TRAVELER_APPLICATION,
  SET_TRANSFER_APPLICATION_ERROR,
  SET_TRANSFER_APPLICATION_SUCCESS,
} from '../actions/types';

const initialState = {
  applicationHash: {},
  applicationLoading: true,
  sameTemplateProgramRanges: [],
  transferErrors: null,
  transferSuccess: null,
  alternateProgramSuccess: null,
  programPhoto: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRAVELER_APPLICATION:
      return {
        ...state,
        applicationHash: action.payload,
        applicationLoading: false,
        programPhoto: (action.payload.program_photo && action.payload.program_photo.program_background) ? action.payload.program_photo.program_background : {},
      };
   
    case SET_TRANSFER_APPLICATION_ERROR:
      return {
        ...state,
        transferErrors: action.payload,
      };
    case SET_TRANSFER_APPLICATION_SUCCESS:
      return {
        ...state,
        transferSuccess: action.payload,
      };
    
    default:
      return {
        ...state,
      };
  }
};
